import { render, staticRenderFns } from "./FormConsentInput.vue?vue&type=template&id=29bfcc20&"
import script from "./FormConsentInput.vue?vue&type=script&lang=js&"
export * from "./FormConsentInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports